module.exports = "<my-profit-summary [summary]=\"summary\" [existNumbersInProfitSummary]=\"existNumbersInProfitSummary\"></my-profit-summary><my-profit-location [locationSales]=\"locationSales\"></my-profit-location><my-profit-product [productSales]=\"productSales\"></my-profit-product><my-profit-employee [employeeSales]=\"employeeSales\"></my-profit-employee>";


//////////////////
// WEBPACK FOOTER
// ./src/app/accounting/profit-loss/profit/profit-index.component.pug
// module id = 882
// module chunks = 0